<template>
  <div
    class="navbar-main flex items-stretch text-chplus-regular text-nav-light"
  >
    <div
      class="flex-1 text-left"
      :class="{ 'border-b-2 lg:border-b-2px border-nav-light': activeTab > 0 }"
    >
      <div v-if="hasMatchedCandidates">
        <router-link
          :to="{ name: 'favorites' }"
          class="text-chplus-regular"
          :class="{ 'font-bold': $router.currentRoute.name === 'favorites' }"
          >{{ $t("components.nav.navbar_main.tab_favorites") }}</router-link
        >
      </div>
      <div v-else>
        <icon-locked />
      </div>
    </div>
    <div
      class="flex-1 px-2"
      :class="{ 'border-b-2 lg:border-b-2px border-nav-light': activeTab > 1 }"
    >
      <div v-if="hasSeenFavorites">
        <router-link
          :to="{ name: 'lists' }"
          class="text-chplus-regular"
          :class="{ 'font-bold': $router.currentRoute.name === 'lists' }"
          >{{ $t("components.nav.navbar_main.tab_lists") }}</router-link
        >
      </div>
      <div v-else>
        <icon-locked />
      </div>
    </div>
    <div
      class="flex-1 text-right"
      :class="{ 'border-b-2 lg:border-b-2px border-nav-light': activeTab > 2 }"
    >
      <div v-if="hasFavoriteList">
        <!-- Vue Router does not call route guards if navigating to the same page -->
        <template
          v-if="
            $router.currentRoute.name === 'dream-teams' ||
              ($router.currentRoute.name === 'results' && hasFavoriteList)
          "
        >
          <button
            class="text-chplus-regular"
            :class="{
              'font-bold':
                $router.currentRoute.name === 'dream-teams' ||
                $router.currentRoute.name === 'results'
            }"
          >
            {{ $t("components.nav.navbar_main.tab_team") }}
          </button>
        </template>
        <template v-else>
          <router-link
            :to="{ name: 'dream-teams' }"
            class="text-chplus-regular"
            >{{ $t("components.nav.navbar_main.tab_team") }}</router-link
          >
        </template>
      </div>
      <div v-else>
        <icon-locked />
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import IconLocked from "@/components/icons/IconLocked";
import { ProgressStepId } from "@/utils/ProgressStepId";

export default {
  name: "Navbar",
  components: { IconLocked },
  data: () => {
    return {
      hasMatchedCandidates: false,
      hasSeenFavorites: false,
      hasCreatedList: false,
      hasFavoriteList: false
    };
  },
  created() {
    this.checkProgression();
  },
  computed: {
    ...mapGetters("user", ["user", "hasProgress"]),
    ...mapGetters("election", ["activeElection"]),
    activeTab() {
      switch (this.$route.name) {
        case "favorites":
          return 1;
        case "lists":
          return 2;
        case "dream-teams":
          return 3;
        case "results":
          return 3;
        default:
          return 0;
      }
    }
  },
  methods: {
    checkProgression() {
      this.hasMatchedCandidates = this.hasProgress(ProgressStepId.Match);
      this.hasSeenFavorites = this.hasProgress(ProgressStepId.Favorites);
      this.hasCreatedList = this.hasProgress(ProgressStepId.CustomList);
      this.hasFavoriteList = this.hasProgress(ProgressStepId.FavoriteList);
    }
  }
};
</script>

<style scoped>
.navbar-main {
  box-sizing: border-box;
  padding: 0 2.25rem;
  height: 100%;
  line-height: 1.25em;
}
.navbar-main a,
.navbar-main button {
  line-height: 1em;
  vertical-align: baseline;
}
@media screen and (min-width: 768px) {
  .navbar-main {
    padding: 0 3.7rem;
  }
}

@media (min-width: 1024px) {
  .navbar-main {
    height: fit-content;
  }
}
</style>
